import styled, { css } from 'styled-components'

import {
  FireCard,
  FireCardContentContainer,
  FireCardImageContainer,
} from '@nx/fire/card'
import { FireImage } from '@nx/fire/image'
import { FireLink } from '@nx/fire/link'
import { Body, Heading, Label } from '@nx/fire/typography'

export const StyledFireCard = styled(FireCard)`
  ${({ theme }) => css`
    position: relative;
    background: #f6f6f6 !important;
    flex-direction: row;
    box-shadow: none;
    border-radius: 3px;

    ${FireCardImageContainer} {
      width: 100px;
    }

    ${FireCardContentContainer} {
      padding: 10px;
    }

    ${theme.media.up.md} {
      flex-direction: column;
      border-radius: 5px;

      ${FireCardImageContainer} {
        width: 100%;
      }

      ${FireCardContentContainer} {
        padding: 0 25px 20px;
      }
    }
  `}
`

export const StyledFireImage = styled(FireImage)`
  ${({ theme }) => css`
    aspect-ratio: 1/2;
    width: 100px;
    height: 100%;
    object-fit: cover;
    border-radius: 3px 0 0 3px;

    ${theme.media.up.md} {
      height: 190px;
      width: 100%;
      border-radius: 5px 5px 0 0;
    }
  `}
`

export const StyledLabel = styled(Body)`
  ${({ theme }) => theme.fontStyles.sourceSans.light};
  text-transform: uppercase;
`

export const StyledHeading = styled(Heading)`
  font-size: 1rem;
`

export const StyledSeparator = styled.hr`
  ${({ theme }) => css`
    display: block;
    width: 50%;
    border: 0;
    ${({ theme }) => theme.helpers.topSeparationLine}
    height: 1px;
    box-sizing: border-box;
    margin: 30px auto;

    ${theme.media.up.md} {
      display: none;
    }
  `}
`

export const StyledFireLink = styled(FireLink)`
  &::after {
    content: '';
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
  }
`

export const StyledCTALabel = styled(Label)`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    margin-top: 10px;
    color: ${theme.colours.primary.primary};

    svg {
      margin-left: 5px;
    }
  `}
`
